import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import view_face_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/view_face.svg';
import { img } from '@phi/components';
import { do_nothing } from '@phi/util';
import { switch_face_view } from '@frontend/scene';
import ViewFaceTooltip from './ViewFaceTooltip';

export const ViewFaceIcon = view_face_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        one_face_selected() {
            return this.state.selected_faces_count === 1
                && this.state.selected_edges_count === 0
                && this.state.selected_vertices_count === 0;
        },

        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'View perpendicular to face';
        },

        disabled() {
            return !this.one_face_selected;
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 3,
            active: false,
            id: 'view-face-button',
            tippy: 'top',
            onClick: this.disabled ? do_nothing : switch_face_view,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(view_face_svg, this.alt),
            tooltip: ViewFaceTooltip,
        });
    },
});
